import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration
// Replace with your actual Firebase config from Firebase Console
const firebaseConfig = {
  apiKey: import.meta.env.REACT_APP_FIREBASE_API_KEY || "YOUR-API-KEY",
  authDomain: import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "chatfile-storage.firebaseapp.com",
  projectId: import.meta.env.REACT_APP_FIREBASE_PROJECT_ID || "chatfile-storage",
  storageBucket: import.meta.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "chatfile-storage.appspot.com",
  messagingSenderId: import.meta.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "YOUR-SENDER-ID",
  appId: import.meta.env.REACT_APP_FIREBASE_APP_ID || "YOUR-APP-ID",
  measurementId: import.meta.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "YOUR-MEASUREMENT-ID"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Analytics (optional)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;